<div class="content-item-details bg-white">

  <div class="content-cart bg-white">
    <div class="header-cart shadow-sm">

      <div class="row form-group pt-1 mb-1">
        <div class="col">

          <div class="row align-items-center">
            <!-- Column 1: Back -->
            <div class="col-2">
              <div (click)="onBackClick()">
                <i class="far icon-back-inline p-4"></i>
              </div>
            </div>

            <!-- Column 2: Title -->
            <div class="col-8 text-center">
              <!-- Title -->
              <label class="text-truncate font-weight-bold mt-2 h6 mb-0">
                <span *ngIf="customerLoyalty.userPkid > 0">
                  {{ customerLoyalty.firstName }}
                </span>
                <span *ngIf="!customerLoyalty.userPkid">Your</span>
                Cart
              </label>

              <div *ngIf="customerLoyalty.userPkid" class="fa-xs-small-70 cursor" (click)="viewReward()">
                <span class="loyalty-tier-badge">
                  {{customerLoyalty.loyalty_tier}}
                </span>
              </div>
              <div *ngIf="customerLoyalty.userPkid" class="text-primary fa-xs-small-70 cursor" (click)="viewReward()">
                Loyalty Bal: {{ totalPoints }} /
                <span *ngIf="userSelectedStore">
                  <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                    {{settings.company_currency}}
                  </small>
                  {{loyaltyAmount.toFixed(2)}}
                  <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                    {{settings.company_currency}}
                  </small>
                </span> Check more
              </div>

              <div *ngIf="customerLoyalty.userPkid" class="font-weight-bold text-primary">Review & redeem Rewards</div>
            </div>


            <!-- Column 3: Menu -->
            <div class="col-2">
              <span (click)="onBackClick()" class="badge rounded-pill bg-dark text-white p-2 cursor">
                Menu
              </span>
            </div>
          </div>


          <div class="row mx-2" *ngIf="IsTableQRCode !== 1" style="display: none;">
            <div class="col-7" style="background-color: #0b2b3d !important;border-radius: 10px 0px 0px 10px;">
              <div style="color: white !important;" class="p-1">
                <!-- <i class="fas font-size-14 fa-motorcycle pr-1"></i> -->
                <span *ngIf="serviceType === 'DELIVERY'">Delivery</span>
                <span *ngIf="serviceType === 'DINE_IN' && !IsLocationQRCode">DineIn</span>
                <span *ngIf="serviceType === 'COLLECTION'">Pickup</span>
                &nbsp;
                <label class="card-title m-0 mb-0 text-capitalize text-break">
                  {{orderDatetime}}
                </label>
              </div>
            </div>
            <div class="col mr-1 text-center"
              style="background-color: #0b2b3d !important;border-radius: 0px 10px 10px 0px;">
              <div style="color: white !important;" class="p-1" *ngIf="distance >= 0">
                <!-- <i class="fas fa-map-marker font-size-14 fa-sm pr-1" style="width:27px;"></i> -->
                Dist&nbsp; {{distance.toFixed(1)}} KM
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="margin-header">
      <ng-container *ngIf="itemIds.length > 0">
        <app-ecom-item-upsell [itemIds]="itemIds" (handleUpsellItem)="handleUpsellItem()"></app-ecom-item-upsell>
      </ng-container>


      <div class="container remove-cart-body">
        <div class="row pt-2" *ngIf="cartEmptyMessage">
          <div class="col text-center text-danger">
            {{cartEmptyMessage}}
          </div>
        </div>
        <div class="row"
          *ngIf="userSelectedStore && userSelectedStore.storeCart && userSelectedStore.storeCart.orderItems">
          <div class="col">
            <div class="row no-gutters pb-2 mt-3 pr-0 item-border-bottom"
              *ngFor="let item of userSelectedStore.storeCart.orderItems; let i=index">
              <div class="col-7">
                <div class="pl-2 card-title font-weight-bold-500 h6 mb-1">
                  {{item.itemName}}
                  <span class="text-primary cursor font-size-xs" *ngIf="item.discounted">
                    <br>DISCOUNT ({{item.discountName}})
                  </span>
                  <span class="text-success cursor font-size-xs" *ngIf="item.hasReward">
                    <br>REWARD ({{item.reward.name}})
                  </span>
                </div>

                <!-- <ng-container *ngIf="item.variantList">
                  <p class="text-muted pl-2 text-break font-color-light-grey mb-0 fa-xs-small-70"
                    *ngFor="let variant of item.variantList">
                    <span *ngIf="variant.variantName">{{variant.variantName}}</span>
                  </p>
                </ng-container> -->

                <ul class="custom-modifier-list text-muted pl-2 text-break font-color-light-grey mb-0 fa-xs-small-70"
                  *ngFor="let modifierset of item.modifierSetList">
                  <li *ngIf="modifierset.modifierSetSelected">
                    <!-- {{modifierset.modifierName}} jj -->
                    <ul class="custom-modifier-list"
                      *ngFor="let modifier of modifierset.modifierOptions; let optionindex=index;">
                      <li *ngIf="modifier.optionSelected">
                        {{modifier.optionName}} {{modifier.optionPrice.toFixed(2)}}
                        <ul class="custom-modifier-list"
                          *ngFor="let option of modifier.selectedOptions; let oindex=index;">
                          <li class="ml-2" *ngIf="modifier.modifiers_into_modifier.length">
                            {{option}} {{option.optionPrice.toFixed(2)}}
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>

                <p class="pl-2 text-break mb-0 fa-xs-small-70 text-danger" *ngIf="item.itemError">
                  {{item.itemError}}
                </p>
                <span class="text-muted fa-xs-small-70 ml-2"
                  *ngIf="item.specialRequest">&gt;&gt;{{item.specialRequest}}&lt;&lt;</span>
                <!-- <br />
                <span (click)="customize(item)" class="ml-2 font-size-11 text-primary cursor">Customize</span> -->
              </div>

              <div class="col-4 text-center">
                <div class="mt-0" *ngIf="item.totalDiscountAmount > 0">
                  <span class="card-text font-size-11 font-weight-bold-500">{{(item.totalPriceBeforeDiscount -
                    item.totalDiscountAmount).toFixed(2)}}-1</span>
                </div>
                <div class="mt-0" *ngIf="item.discountAmount > 0">
                  <del>
                    <!-- old price -->
                    <span class="text-muted card-text font-size-11">{{item.HasModifier ? item.totalPrice?.toFixed(2) :
                      (item.priceEach * item.quantity)?.toFixed(2)}}</span>
                  </del>
                </div>
                <!-- new price -->
                <div class="mt-0">
                  <span class="card-text font-size-11 font-weight-bold-500">{{(item.quantity *
                    item.discountedPrice).toFixed(2)}}</span>
                </div>

                <div class="input-group justify-content-center">
                  <div class="input-group-prepend" *ngIf="!item.discounted && !item.hasReward">
                    <i class="fas a-lg fa-minus cursor font-color-lights-grey p-2 font-size-price"
                      (click)="onQuantityChange('MINUS', item, i)"></i>
                  </div>
                  <div class="text-dark p-1 bg-light bg-white font-size-price">
                    <span>{{item.quantity}}</span><br>
                    <!-- <span (click)="customize(item, i)" class="ml-2 fa-xs-small-70 text-primary cursor">Change</span> -->
                  </div>
                  <div class="input-group-append" *ngIf="!item.discounted && !item.hasReward">
                    <i class="fas fa-plus cursor font-color-lights-grey p-2 font-size-price"
                      (click)="onQuantityChange('PLUS', item, i)"></i>
                  </div>
                </div>
              </div>

              <div class="col-1 text-right mt-3" *ngIf="item.canRemove">
                <i class="fas fa fa-times cursor font-color-lights-grey p-2 font-size-price"
                  (click)="confirmDelete(item, i)"></i>
              </div>
            </div>




            <div class="row pt-2" *ngIf="cartErrorMessage">
              <div class="col text-center text-danger">
                {{cartErrorMessage}}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12"> </div>

        <div class="row" *ngIf="!openForOrders">
          <div class="col text-center">
            <label class="px-3 text-warning font-size-16">
              Sorry you cannot proceed for payment, the restaurant is
              yet to be fully set up on Olarme
            </label>
          </div>
        </div>
        <div style="background: #e2e4e6b7;" class="mt-2 row line-height-1 my-2"
          *ngIf="userSelectedStore && userSelectedStore.storeCart && userSelectedStore.storeCart.orderItems && userSelectedStore.storeCart.orderItems.length > 0">
          <div class="col my-3">
            <div>
              <div class="row px-2 mr-1 line-height-1 mb-2px">
                <div class="col-7 pr-4">
                  <!-- <span class="fa-xs-small-70">Sub Total</span> -->
                  <span>Sub Total</span>
                </div>
                <div class="col-5 text-right pr-2">
                  <span>
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                  {{settings.company_currency}}
                </small> -->
                    {{subTotal.toFixed(2)}}
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                  {{settings.company_currency}}
                </small> -->
                  </span>
                </div>
              </div>

              <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="totalDiscount > 0">
                <div class="col-7 pr-4">
                  <!-- <span class="fa-xs-small-70">Order Discount</span> -->
                  <span>Item Discount</span>
                </div>
                <div class="col-5 text-right pr-2">
                  <span>
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                  {{settings.company_currency}}
                </small> -->
                    {{totalDiscount.toFixed(2)}}
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                  {{settings.company_currency}}
                </small> -->
                  </span>
                </div>
              </div>

              <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="userSelectedStore.storeCart.referral">
                <div class="col-7 pr-4">
                  <!-- <span class="fa-xs-small-70 font-weight-bold-500">Referrals
              disc({{userSelectedStore.storeCart.referral.referral_percentage}}%)</span> -->
                  <span>
                    Referrals
                    disc({{userSelectedStore.storeCart.referral.referral_percentage}}%)
                  </span>
                </div>
                <div class="col-5 text-right pr-2">
                  <span class="font-weight-bold-500">
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                  {{settings.company_currency}}
                </small> -->
                    - {{userSelectedStore.storeCart.orderDiscountReferral.toFixed(2)}}
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                  {{settings.company_currency}}
                </small> -->
                  </span>
                </div>
              </div>

              <div class="row px-2 mr-1 line-height-1 mb-2px" *ngFor="let tax of taxList">
                <div class="col-7 pr-4" *ngIf="tax.display">
                  <!-- <span class="fa-xs-small-70">{{tax.name}}</span> -->
                  <span>{{tax.name}}</span>
                </div>
                <div class="col-5 text-right pr-2" *ngIf="tax.display">
                  <span>
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                  {{settings.company_currency}}
                </small> -->
                    <span *ngIf="tax.amount != '0.00'">
                      {{tax.amount}}
                    </span>
                    <span *ngIf="tax.amount == '0.00'">
                      0.00
                    </span>
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                  {{settings.company_currency}}
                </small> -->
                  </span>
                </div>
              </div>

              <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="totalEntireDiscounts > 0">
                <div class="col-7 pr-4">
                  <span>Order Discount</span>
                </div>
                <div class="col-5 text-right pr-2">
                  <span>
                    {{totalEntireDiscounts.toFixed(2)}}
                  </span>
                </div>
              </div>

              <!-- <div class="row px-2 mr-1 line-height-1 mb-2px">
                <div class="col-7 pr-4">
                  <span>Tax ({{this.settings.company_sell_price_tax === 'TAX_IN' ? 'Inclusive' : 'Exclusive'}})</span>
                </div>
                <div class="col-5 text-right pr-2">
                  <span>
                    {{totalTax.toFixed(2)}}
                  </span>
                </div>
              </div> -->

              <ng-container *ngFor="let item of serviceCharges">
                <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="item.amountSurcharge > 0">
                  <div class="col-7 pr-4">
                    <span>{{item.surchargeName}}</span>
                  </div>
                  <div class="col-5 text-right pr-2">
                    <span>
                      {{item.amountSurcharge.toFixed(2)}}
                    </span>
                  </div>
                </div>
                <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="item.surchargeTax > 0">
                  <div class="col-7 pr-4">
                    <span>Surcharge Tax</span>
                  </div>
                  <div class="col-5 text-right pr-2">
                    <span *ngIf="this.settings.company_sell_price_tax === 'TAX_EX'">
                      {{item.surchargeTax.toFixed(2)}}
                    </span>
                    <span *ngIf="this.settings.company_sell_price_tax === 'TAX_IN'">
                      ({{item.surchargeTax.toFixed(2)}})
                    </span>
                  </div>
                </div>
              </ng-container>
              <div class="row px-2 mr-1 line-height-1 mb-2px" *ngFor="let item of taxArray">
                <div class="col-7 pr-4" *ngIf="item.total > 0">
                  <span>{{item.taxName}}</span>
                </div>
                <div class="col-5 text-right pr-2">
                  <span *ngIf="this.settings.company_sell_price_tax === 'TAX_IN'">
                    ({{item.total.toFixed(2)}})
                  </span>
                  <span *ngIf="this.settings.company_sell_price_tax === 'TAX_EX'">
                    {{item.total.toFixed(2)}}
                  </span>
                </div>
              </div>
              <div class="row px-2 mr-1 line-height-1 mb-2px" *ngIf="serviceType === 'DINE_IN'" style="display: none;">
                <div class="col-7 pr-4">
                  <span>Service Charges<span *ngIf="servicechagePercentage">({{servicechagePercentage}}%)</span></span>
                </div>
                <div class="col-5 text-right pr-2">
                  <span>
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                  {{settings.company_currency}}
                </small> -->
                    {{userSelectedStore.storeCart.orderServiceCharge.toFixed(2)}}
                    <!-- <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                  {{settings.company_currency}}
                </small> -->
                  </span>
                </div>
              </div>

              <!-- <div class="row px-3 line-height-1">
        <div class="col-7 pr-4">
          <span class="fa-xs-small-70">Voucher</span>
        </div>
        <div class="col-5 text-right pr-4">
          <span class="fa-xs-small-70">
            <small *ngIf="settings && settings.company_currency_position === 'BACK'">
              {{settings.company_currency}}
            </small>
            <span></span>
            - {{userSelectedStore.storeCart.voucherAmount.toFixed(2)}}
            <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
              {{settings.company_currency}}
            </small>
          </span>
        </div>
      </div> -->


              <div class="row px-2 mr-1 line-height-1 mb-2px">
                <div class="col-6 pr-4">
                  <span class="font-weight-bold">Total </span>
                </div>
                <div class="col-6 text-right pr-2">
                  <span class="font-weight-bold">
                    <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                      {{settings.company_currency}}
                    </small>

                    {{total.toFixed(2)}}
                    <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                      {{settings.company_currency}}
                    </small>
                  </span>
                </div>
              </div>
            </div>

            <div class="row px-3 line-height-1 pt-2 mb-2px" *ngIf="false">
              <div class="col text-right">
                <span class="text-primary cursor" (click)="onSignInClick()">
                  <img src="assets/images/homeicons/referral.png" style="width: 7%;height: auto;" alt="">
                  {{'CART_PAGE.REFERRAL_DISCOUNT' | translate }}
                </span>
              </div>
            </div>

          </div>
        </div>

        <div class="row px-2 mb-2" style="background: #e2e4e6b7;" *ngIf="false">
          <div class="col p-2">


            <div class="row mt-2">
              <div class="col text-right">
                <span class="text-primary cursor mr-3 cursor">
                  <img src="assets/images/homeicons/promotions.png" style="width: 7%;height: auto;" alt="">
                  {{'CART_PAGE.EXPLORE_AND_APPLY' | translate }}
                </span>
                <!-- <span class="text-primary cursor mr-3 cursor" (click)="onSignInClick()"
                *ngIf="!usertoken">Login to explore and apply promotional offers</span> -->
              </div>
            </div>

          </div>
        </div>

        <div class="row px-2 background-grey shadow-sm text-primary">
          <div class="col p-2">
            <div>
              <div class="row">
                <div class="col font-weight-bold-500">{{'COMMON.AMOUNT_TO_PAY' | translate }}</div>
                <div class="col text-right mr-3">
                  <div>
                    <span class="font-weight-bold" *ngIf="userSelectedStore">
                      <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                        {{settings.company_currency}}
                      </small>
                      {{total.toFixed(2)}}
                      <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                        {{settings.company_currency}}
                      </small>
                    </span>
                  </div>
                  <div *ngIf="OrderTotalAmountBeforeCashback !== AmountToPay">
                    <del class="font-weight-bold">
                      <small class="font-weight-bold">
                        <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                          {{settings.company_currency}}
                        </small>
                        <span *ngIf="userSelectedStore && userSelectedStore.storeCart">
                          {{(OrderTotalAmountBeforeCashback).toFixed(2)}}
                        </span>
                        <span *ngIf="userSelectedStore && !userSelectedStore.storeCart">
                          0.00
                        </span>
                        <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                          {{settings.company_currency}}
                        </small>
                      </small>
                    </del>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="footer-cart bg-white pb-2">
    <div class="container pl-0 pr-0">
      <div class="row">
        <div class="col">
          <div class="row no-gutters">
            <div class="col border-right">
              <button type="button" class="btn bg-dark text-white btn-block btn-sm box-shadow-none border-radius-0 p-2"
                (click)="viewReward()">
                <div class="font-weight-bold" style="font-size: larger;">{{'COMMON.VIEW_REWARD' | translate }}
                </div>
              </button>
            </div>
            
            <!-- <div class="col pl-0" *ngIf="this.userSelectedStore.userConfirmedChange">
              <button type="button"
                class="btn bg-dark text-white btn-block btn-sm box-shadow-none border-radius-left p-2"
                (click)="recalculateDiscounts()">
                <div class="font-weight-bold" style="font-size: larger;">Calculate Discounts</div>
              </button>
            </div> -->
            <div class="col pl-0" *ngIf="!openForOrders">
              <button type="button"
                class="not-allowed btn bg-dark text-white btn-block btn-sm box-shadow-none border-radius-left p-2"
                disabled>
                <div class="font-weight-bold" style="font-size: larger;">{{'CART_PAGE.ORDER_NOW' | translate }}</div>
              </button>
            </div>
            <div class="col pl-0" *ngIf="openForOrders">
              <button type="button"
                class="btn bg-dark text-white btn-block btn-sm box-shadow-none border-radius-left p-2"
                (click)="active === 0 ? onCheckoutClick() : null" [disabled]="this.ecomservice.isLoading">
                <div class="font-weight-bold" style="font-size: larger;">{{'CART_PAGE.ORDER_NOW' | translate }}</div>
              </button>
            </div>
          </div>
          <!-- <div class="row" *ngIf="serviceType !== 'DINE_IN'">
            <div class="col" *ngIf="!openForOrders">
              <button type="button"
                class="not-allowed btn bg-dark text-white btn-block btn-sm box-shadow-none border-radius-left p-2"
                disabled>
                <div class="font-weight-bold" style="font-size: larger;">Order Now 3</div>
              </button>
            </div>
            <div class="col" *ngIf="openForOrders">
              <button type="button"
                class="btn bg-dark text-white btn-block btn-sm box-shadow-none border-radius-left p-2"
                (click)="onCheckoutClick()">
                <div class="font-weight-bold" style="font-size: larger;">Order Now 4</div>
              </button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #sessionExpired>
  <!-- <div class="modal-header text-center">    
    <i class="fas fa-times fa-lg cursor close" (click)="closePromo()"></i>
  </div> -->
  <div class="modal-body rounded">
    <div class="row form-group">
      <div class="col text-center">
        <label class="h3">Your session expired due to inactivity!!</label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <button type="button" style="background-color:#151617 !important;"
          class="btn btn-block btn-sm btn-outline-secondary border-1 border-light-grey outline-0 box-shadow-none font-weight-bold font-size-11 pt-1 pb-1 bg-white"
          (click)="onSessionExpired()">
          <span style="color: #fffb04 !important;">OK</span>
        </button>
      </div>
    </div>

  </div>
</ng-template>


<ng-template #orderstatus>
  <div class="modal-body rounded">
    <div class="row form-group">
      <div class="col text-center">
        <label class="h3">Your food order
          <span *ngIf="customer_order">
            {{customer_order.ooco_sales_order_id}}
          </span>
          successfully sent
        </label>
      </div>
    </div>
    <div class="row form-group">
      <div class="col text-center">
        <button type="button" class="badge rounded-pill btn bg-dark-blue text-white box-shadow-none p-2 rounded"
          (click)="onCheckStatusClick()">
          Check Status
        </button>
      </div>
    </div>

  </div>
</ng-template>
<div id="map" class="map"></div>
<ng-template #discountWarning>
  <div class="modal-header">

    <div class="col font-weight-bold-500 text-center">{{'CART_PAGE.ALERT' | translate }}
    </div>


  </div>
  <div class="modal-body">
    <div class="col font-weight-bold-500 text-center">
      {{'CART_PAGE.UNGROUP_WARNING' | translate }}

    </div>

    <div class="row mt-3">

      <div class="col-6">
        <button (click)="cancel()"
          class="btn btn-outline-secondary btn-block bg-dark text-white box-shadow-none">{{'CART_PAGE.CANCEL' |
          translate }}</button>
      </div>
      <div class="col-6">
        <button (click)="goAhead()" class="btn btn-outline-secondary btn-block bg-dark-blue text-white box-shadow-none">
          {{'CART_PAGE.REMOVE' | translate }}
        </button>
      </div>

    </div>


  </div>
</ng-template>
<app-toast [message]="toastMessage" [visible]="showToast"></app-toast>
<app-drawer [(visible)]="drawerVisible" (visibleChange)="onDrawerVisibleChange($event)">
  <ng-container *ngIf="drawerVisible && item_pkid">
    <app-ecom-item-details2 [item]="item" [onClose]="onClose" [item_pkid]="item_pkid" [iscvsd_pkid]="iscvsd_pkid"
      [category_pkid]="category_pkid"></app-ecom-item-details2>
  </ng-container>
</app-drawer>

<app-drawer [customClass]="showModifierPopup ? '' : 'reward'" [(visible)]="rewardVisible"
  (visibleChange)="closeRewardPopup()">

  <div class="container py-2" *ngIf="!showModifierPopup">
    <div class="row justify-content-center">
      <div class="col-12 reward-box">

        <div class="p-2 card-tier">


          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
              <h4>{{customerLoyalty.programCurrency ? customerLoyalty.programCurrency : 'Points'}}</h4>
              <h4>Balance</h4>
            </div>

            <div class="d-flex align-items-center mr-5" style="height: 40px;">
              <h3 class="font-weight-bold mb-0">{{totalPoints}} /
                <span class="font-weight-bold" *ngIf="userSelectedStore">
                  <small class="fa-xs-small-70" *ngIf="settings && settings.company_currency_position === 'BACK'">
                    {{settings.company_currency}}
                  </small>
                  {{loyaltyAmount.toFixed(2)}}
                  <small class="fa-xs-small-70" *ngIf="settings && settings.company_currency_position === 'FRONT'">
                    {{customerLoyalty.company_currency}}
                  </small>
                </span>
              </h3>
            </div>
          </div>




          <!-- Progress bar -->
          <div class="progress my-1" style="height: 6px;">
            <div class="progress-bar bg-warning" role="progressbar" style="width: 76%;" aria-valuenow="380"
              aria-valuemin="0" aria-valuemax="500"></div>
          </div>

          <div class="d-flex justify-content-between small text-muted">
            <span class="loyalty-tier-badge" *ngIf="customerLoyalty.userPkid">
              {{customerLoyalty.loyalty_tier}}
            </span>
            <span class="text-primary">(Spend {{customerLoyalty.spend_more}} more for {{customerLoyalty.next_tier}}
              tier)</span>
          </div>

          <div class="mt-1 text-muted small">
            Click a reward to add to cart
          </div>
        </div>

        <div class="reward-item-box cursor" *ngIf="rewardDetails">
          <div class="row align-items-center">
            <div class="col-4 text-center">
              <div class="circle mb-2"></div>
            </div>
            <div class="col-8">
              <p class="mb-1 bold">{{rewardDetails.name}}</p>
              <p class="mb-1">{{rewardDetails.point}}</p>
              <!-- <p class="mb-1 bold">bdbdb</p> -->
              <p class="cursor" style="color: orange;font-weight: bolder;" (click)="hideRewardDetails()">
                HIDE</p>
            </div>
          </div>
          <div class="row align-items-center bold">
            <div class="container">
              <div class="row g-2">
                <div class="col-1"></div>
                <div class="col-5 text-end bold">Reward Value</div>
                <div class="col-6">
                  {{rewardDetails.reward_value}}
                </div>
                <div class="col-1"></div>
                <div class="col-5 text-end">Item</div>
                <div class="col-6">
                  {{rewardDetails.item_name}}
                </div>
                <div class="col-1"></div>
                <div class="col-5 text-end">Reward Expiry</div>
                <div class="col-6">
                  {{rewardDetails.expiry}}
                </div>
                <div class="col-1"></div>
                <div class="col-5 text-end">Tier</div>
                <div class="col-6">
                  {{rewardDetails.tiers}}
                </div>
                <div class="col-1"></div>
                <div class="col-5 text-end">Remarks</div>
                <div class="col-6">
                  {{rewardDetails.remarks}}
                </div>
              </div>
            </div>


          </div>
        </div>
        <!-- Balance -->
        <div class="mb-2" style="display: none;">
          <p class="bold mb-0">Points</p>
          <h3 class="text-primary">50000</h3>
          <span>Click a reward to add to cart</span>
        </div>

        <!-- Wrapper scroll -->
        <div *ngIf="!rewardDetails" class="overflow-auto">
          <!-- Item -->
          <div (click)="checkReward(item)" class="reward-item-box me-3 mr-2 cursor" style="min-width: 300px;"
            *ngFor="let item of activeRewards" [class.redeemed]="item.is_redeemed">
            <div class="d-flex align-items-center">
              <!-- LEFT: fixed -->
              <div class="flex-shrink-0" style="width: 130px;">
                <div class="circle mx-auto shadow-sm" [ngClass]="{
      'icon-birthday': item.type === 'BIRTHDAY_BONUS',
      'icon-welcome': item.type === 'WELCOME_BONUS' || item.type === 'BENEFIT_COUNT'
    }">
                  <img class="category-image" *ngIf="item.item_image && item.item_image.length"
                    [defaultImage]="defaultImage" [lazyLoad]="item.item_image" />

                  <div class="reward-fallback"
                    *ngIf="(!item.item_image || !item.item_image.length) && item.value_type === 'AMOUNT'">
                    <span class="reward-fallback-amount">{{item.reward_value.toFixed(2)}}</span>
                    <span class="reward-fallback-label">RM OFF</span>
                  </div>
                </div>
              </div>

              <!-- RIGHT: auto fill -->
              <div class="flex-grow-1">
                <p class="mb-1 bold">{{item.name}}</p>
                <p class="mb-1 text-primary bold">{{item.point}} pts</p>
                <p class="mb-1 bold">
                  {{item.item_name}} {{item.variant_name ? ' - ' + item.variant_name : ''}}
                </p>
                <p class="mb-1 bold text-muted small" *ngIf="item.description">
                  {{item.description}}
                </p>

                <p class="cursor" style="color: orange;font-weight: bolder;" (click)="viewRewardDetails($event,item)"
                  *ngIf="false">
                  MORE
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Label row -->
        <div *ngIf="!rewardDetails" class="reward-scroll-wrapper" style="display: none;">
          <div class="d-flex flex-nowrap small-text text-center gap-2">
            <div *ngFor="let item of rewardMenu" class="mr-1 menu-option px-3 py-2 text-nowrap text-center"
              [class.active]="selectedMenuReward === item.key" (click)="getFilteredRewards(item)">
              <div class="d-flex flex-column align-items-center">
                <span>{{ item.topText }}</span>
                <span class="font-size-xs">{{ item.bottomText }}</span>
              </div>
            </div>
          </div>
        </div>




        <ng-container *ngIf="!rewardDetails">
          <div class="reward-item-box cursor" *ngFor="let reward of filteredrewards" style="display: none;">
            <div class="row align-items-center">
              <div class="col-4 text-center">
                <div class="circle mb-2" [ngClass]="{
                    'icon-birthday': reward.type === 'BIRTHDAY_BONUS',
                    'icon-welcome': reward.type === 'WELCOME_BONUS' || reward.type === 'BENEFIT_COUNT'
                   }">
                </div>
              </div>
              <div class="col-8 text-right">
                <p class="mb-1 bold text-blue">{{reward.name}}</p>
                <p class="mb-1 text-blue" *ngIf="reward.point > 0">{{reward.point}}pts</p>
                <p class="mb-1 bold text-blue">{{reward.item_name}} pts</p>
                <p class="mb-1 bold text-blue">ENDED {{reward.end_date | date: 'MM/dd/yyyy'}}</p>
                <p class="mb-1">{{reward.remarks}}</p>
                <!-- <p class="cursor" style="color: orange;font-weight: bolder;" (click)="viewRewardDetails($event,reward)"
                    *ngIf="
  reward.type !== 'WELCOME_BONUS' &&
  reward.type !== 'BIRTHDAY_BONUS' &&
  reward.type !== 'REFERRAL_ADVOCATE' &&
  reward.type !== 'REFERRAL_FRIEND'
">
                    MORE</p> -->
              </div>
            </div>
          </div>
        </ng-container>






      </div>


    </div>
  </div>

  <div *ngIf="showModifierPopup">
    <div class="col-12">
      <div class="pl-2 mt-2 card-title font-weight-bold-500 h6 mb-1">
        Please select modifier options
      </div>

    </div>
    <div *ngFor="let item of freeRewards;let e=index;trackBy:guid">
      <ng-container *ngIf="item.modifierSetList && item.modifierSetList.length > 0">
        <div class="row item-border-bottom">

          <div class="col-12">
            <div class="pl-2 mt-2 mb-1">
              <span class="card-title font-weight-bold-500 h6">{{item.itemName}}, Quantity {{item.itemIndex}} of
                {{totalModItems}}</span>
            </div>

          </div>

        </div>
        <!-- free modifier -->
        <div class="row no-gutters form-group">
          <div class="col">
            <div class="row cursor" *ngFor="let modifier of item.modifierSetList;let i=index;">
              <div class="col">
                <div class="row bg-light" (click)="onModifierSetClick3(item,modifier,i,modifier.collapsed)"
                  [attr.aria-expanded]="modifier.collapsed" aria-controls="modifier.modifierName">
                  <div class="col background-grey">
                    <div class="row">
                      <div class="col background-grey">
                        <label class="cursor" class="text-dark fw-500 m-0 p-2">
                          <!-- {{modifier.modifierName}} -->
                          {{modifier.modifierCaption}}
                          <span *ngIf="modifier.modifierSetMax">
                            (Pick upto {{modifier.modifierSetMax}})
                          </span>
                        </label>
                      </div>
                      <div class="col-4 background-grey text-right"
                        *ngIf="!modifier.modifierOptions[0].modifiers_into_modifier.length">
                        <label class="m-0 p-2">
                          Price ({{settings.company_currency}})
                        </label>
                      </div>
                      <div class="col-1 background-grey"
                        *ngIf="!modifier.modifierOptions[0].modifiers_into_modifier.length">
                        <label class="text-dark m-0 float-right p-2 pt-08 pr-2 cursor">
                          <i class="fas fa-chevron-up float-right" *ngIf="modifier.collapsed"></i>
                          <i class="fas fa-chevron-down float-right" *ngIf="!modifier.collapsed"></i>
                        </label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <span class="pl-2 text-danger" *ngIf="modifier.errorMessage">
                          {{modifier.errorMessage}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="{{modifier.modifierName}}" [collapse]="modifier.collapsed" [isAnimated]="true"
                  class="container">
                  <div class="row border-bottom pt-2" *ngFor="let option of modifier.modifierOptions;let j=index;">
                    <div class="col" *ngIf="!option.modifiers_into_modifier.length">
                      <div class="row">
                        <div class="col-1 mt-1 cursor">
                          <div class="round" *ngIf="option.modifiers_into_modifier">
                            <input [checked]="option.optionSelected" name="{{option.optionPkid}}-{{e}}" type="checkbox"
                              id="{{option.optionPkid}}-{{e}}"
                              (change)="onCombinationModifierOptionChecked($event,item, modifier,option,i,j, e)" />
                            <label class="cursor" for="{{option.optionPkid}}-{{e}}"></label>
                          </div>
                        </div>
                        <div class="col">
                          <label for="{{option.optionPkid}}-{{e}}"
                            class="pl-2 pt-1 text-dark cursor">{{option.optionName}}</label>
                        </div>
                        <div class="col-3 text-right">
                          <label>

                            {{option.optionPrice}}

                          </label>
                        </div>
                        <div class="col-1"></div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </ng-container>
    </div>
    <div class="row">


      <div class="col-12">
        <button (click)="addCombinationToCart()"
          class="btn btn-outline-secondary btn-block bg-dark-blue text-white box-shadow-none">Add To Cart</button>
      </div>

    </div>
  </div>
</app-drawer>

<ng-template #rewardWarning>
  <div class="modal-body modal-styles">
    <div class="row">
      <div class="col m-2">
        <p>The payment must be completed online to apply rewards</p>
        <p>If you wish to pay at counter, place your order without seletecting rewards</p>
        <p>Request Cashier to add rewards at the time of payment.</p>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button style="border-radius: 10px !important;" type="button"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4" (click)="ok()">
          OK
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #rewardTermsModal>
  <div class="modal-body modal-styles">
    <div class="row">
      <div class="col m-2">
        <p>This reward of RM {{seletecReward ? seletecReward.reward_value.toFixed(2) : 0}} can only be used for one time
          purchase.</p>
        <p>If used for lesser amount (less than {{seletecReward ? seletecReward.reward_value.toFixed(2) : 0}}), the
          balance amount cannot be used again.</p>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button style="border-radius: 10px !important;" type="button"
          class="btn cart-btn-paylater font-weight-bold-500 box-shadow-none mr-2 rounded pl-4 pr-4"
          (click)="okRewardTerms()">
          OK
        </button>
      </div>
    </div>
  </div>
</ng-template>